import { AxiosInstance } from "axios";
import { ApiService } from '../model/Api.model';
import { IExpenseComment } from '../interface/Expense/IExpenseComment';
import { IExpenseCommentRequest } from '../interface/Expense/IExpenseCommentRequest';
import { IBaseResponse } from '../interface/IBaseResponse';

enum ExpenseCommentServiceEnum {
  getByExpenseId = "/",
  putUpdate = "/",
  postCreate = "/"
}

export class ExpenseCommentService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/expense/comment");
  }

  public getByExpenseId = async (expenseId: number): Promise<IExpenseComment[]> => await this.GET(ExpenseCommentServiceEnum.getByExpenseId + expenseId);
  public update = async (expenseCommentId: number, expenseComment: IExpenseCommentRequest): Promise<IBaseResponse> =>
    await this.PUT(ExpenseCommentServiceEnum.putUpdate + expenseCommentId, expenseComment);
}
